import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-einkakennsla',
  templateUrl: './einkakennsla.component.html',
  styleUrls: ['./einkakennsla.component.css']
})
export class EinkakennslaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
